import React, { useEffect } from 'react';
import { Typography } from 'antd';
import Layout from './Layout';

const { Text, Title } = Typography;

const EmployeeChatPage = () => {
    useEffect(() => {
        window.dispatchEvent(
            new CustomEvent('crm-chat-open')
        );
    }, []);

    return (
        <Layout>
            <Title level={4} style={{ marginTop: 0 }}>
                Чат сотрудников
            </Title>
            <Text type="secondary">
                Панель чата закреплена в левом нижнем
                углу. Нажмите на значок «Чат», если окно
                закрыто.
            </Text>
        </Layout>
    );
};

export default EmployeeChatPage;
